import React from 'react';

const AuthorityStripe = () => {
    return (
        <div style={{
            background: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            padding: '0.25rem 0',
            textAlign: 'center',
            fontSize: '0.65rem',
            fontWeight: 800,
            color: '#94a3b8',
            textTransform: 'uppercase',
            letterSpacing: '0.12em',
            display: 'flex',
            justifyContent: 'center',
            gap: '1.5rem',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        }} className="desktop-only">
            <span>✓ We literally can't see your data</span>
            <span>✓ Runs entirely on your own machine</span>
            <span>✓ No shady background tracking</span>
            <span>✓ Built by engineers, for engineers</span>
            <span>✓ No server uploads ever</span>
            <span>✓ Completely free forever</span>
        </div>
    );
};

export default AuthorityStripe;
